var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDarkModeLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9672 12.768C19.6195 13.6956 17.9895 14.1219 16.3602 13.9727C14.731 13.8236 13.2054 13.1085 12.0485 11.9516C10.8916 10.7947 10.1765 9.26919 10.0274 7.63993C9.87828 6.01066 10.3046 4.38063 11.2322 3.03296C9.52383 3.17924 7.8928 3.81047 6.53106 4.85237C5.16932 5.89427 4.13354 7.30348 3.54562 8.91414C2.9577 10.5248 2.8421 12.2699 3.21244 13.944C3.58277 15.6182 4.42363 17.1517 5.63604 18.3641C6.84845 19.5765 8.38197 20.4174 10.0561 20.7877C11.7302 21.158 13.4753 21.0424 15.086 20.4545C16.6967 19.8666 18.1059 18.8308 19.1478 17.4691C20.1897 16.1073 20.8209 14.4763 20.9672 12.768Z",
    fill: "#02B37F"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkModeLight);
export default __webpack_public_path__ + "static/media/dark_modeLight.4159208476939198c03579e46b110858.svg";
export { ForwardRef as ReactComponent };